export const userProfile = {
  user_alias: "Alias",
  user_name: "Nombre",
  user_lastName: "Apellido",
  user_email: "Correo",
  user_phoneNumber: "Teléfono",
  user_birthdate: "Fecha de Nacimiento",
  user_national_id: "Cédula",
  user_state: "Estado",
  user_city: "Ciudad",
  user_support_message:
    "Para realizar cualquier cambio o actualización a su perfil, por favor comuníquese con nuestro departamento de",
  user_support_link: "soporte técnico",

  userProfileImageFormat: "Formato no soportado",
  userProfileImageFormatDesc: "Solo se permiten imágenes JPEG, JPG o PNG.",
  userProfileImageSize: "Imagen demasiado grande",
  userProfileImageSizeDesc: "El tamaño máximo permitido es 3MB.",
  userProfileImageEdit: "Editar",
};
